export class Input {
  constructor(difference) {
    this.width = 400
    this.height = 40
    this.top = 10
    this.left = 10
    this.innerElement = "cxInput"
    this.bgType = "纯色" //纯色 线性渐变 径向渐变
    this.bgColor = "rgba(255,255,255,1)"
    this.bgStartColor = "rgba(23,241,255,1)"
    this.bgEndColor = "rgba(23,116,255,1)"
    this.fontFamily = "sans-serif"
    this.fontSize = 14
    this.lineHeight = 14
    this.fontWeight = 400
    this.fontStyle = "normal"
    this.rotate = 0
    this.textDecoration = "none"
    this.letterSpacing = 0
    this.textAlign = "left"
    this.writingMode = "horizontal-tb"
    this.padding = 0
    this.paddingTop = 0
    this.paddingRight = 0
    this.paddingLeft = 0
    this.paddingBottom = 0
    this.borderTypeFlag = 2
    this.borderWidth = 0
    this.borderStyle = "solid"
    this.borderColor = "#000000"
    this.borderIsThemeColor = false
    this.iconPosition = "left" // left,right
    this.iconSrc = ""
    this.iconType = "img" // img,icon 图片和字体图标
    this.iconWidth = 14
    this.iconMargin = 10
    this.iconColorIsThemeColor = false
    this.iconColor = "#333"
    this.skew = 0
    this.placeholder = "请输入关键词"
    this.inputTypeVal = "text"
    this.borderTopLeftRadius = 0
    this.borderTopRightRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.opacity = 100
    this.boxShadowColor = ["rgba(255,255,255,1)"]
    this.boxShadowH = [0]
    this.boxShadowV = [0]
    this.boxShadowBlur = [0]
    this.boxShadowSpread = [0]
    this.inputValue = ""
    this.placeHolderFontFamily = "sans-serif"
    this.placeHolderFontSize = 14
    this.placeHolderFontWeight = "400"
    this.placeHolderFontColor = "rgba(172, 180, 191, 1)"
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
